module.exports = __webpack_public_path__ + "static/flyout-menu-1953bb544bdd72cab451680a7c6aa1aa.png";